import styles from "~styles.module.css";
import * as React from "react";
import { JSONTree } from "react-json-tree";
import { Request } from "~types";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { format } from "date-fns";

function checkJSON(x: string): boolean {
  try {
    JSON.parse(x);
    return true;
  } catch {
    return false;
  }
}

export function RequestComponent(props: { request: Request }) {
  const { request: r } = props;
  return (
    <div style={{ display: "flex" }}>
      <span style={{ marginRight: 8 }}>
        {format(r.received, "hh:mm:ss aa")}
      </span>
      <details style={{ marginBottom: 8, flexGrow: 1 }}>
        <summary style={{ marginBottom: 8 }}>
          <span className={styles.box} style={{ marginRight: 8 }}>
            {r.method.toUpperCase()}
          </span>
          {r.count > 1 && (
            <span
              className={styles.box}
              style={{ marginRight: 8, backgroundColor: "#D3BAFD" }}
            >
              x{r.count}
            </span>
          )}
          <span>{r.uri}</span>
        </summary>
        <div style={{ marginLeft: 24 }}>
          {Object.keys(r.headers).map((h) => (
            <p style={{ margin: 0 }}>
              {h}: {r.headers[h].join(", ")}
            </p>
          ))}
          <hr />
          <div
            style={{
              backgroundColor: "#06060A",
              padding: 8,
              paddingTop: 3,
              paddingLeft: 16,
              borderRadius: 8,
              marginBottom: 16,
              position: "relative",
            }}
          >
            {r.body && (
              <span
                className={styles.hoverUnderline}
                style={{
                  position: "absolute",
                  display: "block",
                  right: 4,
                  padding: 4,
                  fontSize: 16,
                  cursor: "pointer",
                  zIndex: 999,
                }}
                onClick={() => {
                  copy(r.body);
                  toast("Copied!", {
                    toastId: "copy",
                    autoClose: 1500,
                    theme: "dark",
                    type: "success",
                  });
                }}
              >
                COPY
              </span>
            )}
            {checkJSON(r.body) ? (
              <JSONTree
                data={JSON.parse(r.body)}
                theme={{ base00: "#06060A" }}
              />
            ) : (
              <p style={r.body ? {} : { fontStyle: "italic" }}>
                {r.body ? r.body : "<empty body>"}
              </p>
            )}
          </div>
        </div>
      </details>
    </div>
  );
}
